import React, { Fragment, useContext, useState, useEffect } from "react";
import {
  FirstName,
  LastName,
  Phone,
  EmailAddress,
  Country,
  CountryMenu,
  Address,
  TownCity,
  StateCountry,
  PostalCode,
  CheckMeOut,
  PlaceOrder,
  Treatment,
} from "../../../../Constant";
import { Btn, H5, H6, P, UL, LI } from "../../../../AbstractElements";
import { Col, Form, FormGroup, Input, Label, Row, Button } from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import CustomizerContext from "../../../../_helper/Customizer";
import { EditTreatmentPayment, TreatmentPayment } from "../../../../apiController";
import { toast } from "react-toastify";

const CheckoutTableData = ({ rowData, data, permission }) => {
  const { layoutURL } = useContext(CustomizerContext);
  const history = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [edit, setEdit] = useState(false);

  // storePayment({
  //   "date": ,
  //   "appointment_id": ,
  //   "patient_id": ,
  //   "discount_type": ,
  //   "discount": ,
  //   "already_paid":,
  //   "paid_amt": ,
  //   "discount_amt": ,
  //   "balance":,
  //   "status":,
  //   "total_amt": ,
  // })

  console.log(rowData);

  const payment = rowData.payment && rowData.payment.length > 0 ? rowData.payment[0] : null;
  const dueAmount = payment.discount_amt === null ? payment.total : payment.discount_amt  - payment.already_paid_amount === null? 0 : payment.already_paid_amount ;
  const calculateAmount = (total, discount) => {
    if (discount == null || discount === "") return total;
    return total - (total * discount) / 100;
  };

  const calculateFlatrate = (total, rate) => {
    return total - (rate || 0);
  };

  const [discountedAmount, setDiscountedAmount] = useState(0);

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    reset,
    watch,
    setValue
  } = useForm();

  const watchDiscountType = watch("discountType");
  const watchDiscount = watch("discount");
  const watchAmount = watch("amount");

  useEffect(() => {
    setValue('discountType', rowData.payment[0].discount_type?  rowData.payment[0].discount_type : watchDiscountType )
    setValue('discount', rowData.payment[0].discount?  rowData.payment[0].discount : watchDiscount )
    const totalAmount = rowData.payment.reduce((acc, t) => acc + t.total, 0);

    let discountAmount;
    if (watchDiscountType === "discount") {
      discountAmount = calculateAmount(totalAmount, watchDiscount);
    } else if (watchDiscountType === "flatrate") {
      discountAmount = calculateFlatrate(totalAmount, watchDiscount);
    } else {
      discountAmount = totalAmount;
    }

    setDiscountedAmount(discountAmount);

  }, [watchDiscountType, watchDiscount, watchAmount, rowData.payment]);

  const onSubmit = (formData) => {
    const { discountType, discount, amount } = formData;
    const totalAmount = rowData.payment.reduce((acc, t) => acc + t.total, 0);

    let discountAmount;
    if (discountType === "discount") {
      discountAmount = calculateAmount(totalAmount, discount);
    } else if (discountType === "flatrate") {
      discountAmount = calculateFlatrate(totalAmount, discount);
    } else {
      discountAmount = totalAmount;
    }

    const balance = discountAmount - amount;

    // Handle the data (e.g., send it to an API or update state)
    console.log("Discount Type:", discountType);
    console.log("Discount Amount:", discountAmount);
    console.log("Paid Amount:", amount);
    console.log("Balance:", balance);
    const appointmentIds = rowData.payment.map((d) =>
      d.services.map(t => t.appointment_id)
    );


    const formettedData = {
      date: rowData.date,
      // appointment_id: rowData.payment.map((d) =>
      //   d.services[0].appointment_id
      // ),
      appointment_id: appointmentIds,
      
      patient_id: data.id,
      discount_type: rowData.payment[0].discount_type !== null?  rowData.payment[0].discount_type : discountType === undefined? null : discountType,
      discount: rowData.payment[0].discount?  rowData.payment[0].discount : discount === undefined? null : discount,
      already_paid: rowData.payment[0].already_paid_amount ?  rowData.payment[0].already_paid_amount : 0,
      paid_amt: amount,
      discount_amt: discountAmount,
      balance: balance,
      status: rowData.payment[0].services[0].appointment_status,
      total_amt: rowData.payment[0].total,
    };

    console.log(formettedData);

    if (edit) {
      const updateFormattedData = {
        patient_id: data.id,
        id: rowData.payment[0]["payment_id"],
        paid_amt: amount
      };
      updateTreatmentPayment(updateFormattedData);
    } else {
      treatmentPayment(formettedData);
    }
    
  };

  const treatmentPayment = async (prep) => {
    setIsSubmitting(true);
    try {
      const response = await TreatmentPayment(prep);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      reset();
      setIsSubmitting(false);
      // history(`/patientinfo/payment`, { state: { data, rowData } });
    }
  };
  const updateTreatmentPayment = async (prep) => {
    setIsSubmitting(true);
    try {
      const response = await EditTreatmentPayment(prep);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      reset();
      setIsSubmitting(false);
      history(`/patientinfo/payment`, { state: { data, rowData } });
    }
  };

  const handleBack = () => {
    history(`/patientinfo/payment`, { state: { data , rowData}});
}
  return (
    <Fragment>
      <Col xl="6" sm="12" className="pb-4">
        <Form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <Row>
            <FormGroup className="mb-3 col-sm-6 text-primary">
              <Label className="text-secondary">{FirstName}</Label>
              <H5>{data.first_name}</H5>
            </FormGroup>
            <FormGroup className="mb-3 col-sm-6 text-primary">
              <Label className="text-secondary">{LastName}</Label>
              <H5>{data.surname}</H5>
            </FormGroup>
          </Row>
          <Row>
            <FormGroup className="mb-3 col-sm-6">
              <Label className="text-secondary">{Phone}</Label>
              <p>{data.phone}</p>
            </FormGroup>
            <FormGroup className="mb-3 col-sm-6">
              <Label className="text-secondary">{Treatment}</Label>
              {rowData.payment.map((t) =>
                t.services.map((p, i) => (
                  <span key={i}>
                    {JSON.parse(p.patient_treatment)?.itemsPr?.map((t) => (
                      <p className="p-0 m-0" key={t.mname}>
                        {t.mname}
                      </p>
                    ))}{" "}
                    <br />
                  </span>
                ))
              )}
            </FormGroup>
          </Row>
          <FormGroup className="mb-3">
            <Label>{"Discount Type"}</Label>
            {/* Check if any discount_type is null or undefined */}
            {rowData.payment.some(
              (d) => d.discount_type === null || d.discount_type === undefined
            ) ? (
              <Controller
                name="discountType"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Input {...field} type="select">
                    <option value="">{"Select Discount Type"}</option>
                    <option value="discount">{"Discount %"}</option>
                    <option value="flatrate">{"Flat Rate "} &#x20B9;</option>
                  </Input>
                )}
              />
            ) : (
              <P>{rowData.payment[0]?.discount_type || "N/A"}</P>
            )}
          </FormGroup>

          <FormGroup className="mb-3">
            <Label for="discount">{"Discount"}</Label>
            {rowData.payment.some(
              (d) => d.discount === null || d.discount === undefined
            ) && permission?.create_access ? (
              <>
                <Controller
                  name="discount"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <Input
                      {...field}
                      type="number"
                      min="0"
                      max={watchDiscountType === 'discount' ? "100" : ''}
                      step="0.01"
                    />
                  )}
                />
                <span style={{ color: "#ff5370" }}>
                  {errors.discount && "Please enter a valid discount."}
                </span>
              </>
            ) : (
              <P>{rowData.payment[0]?.discount || "N/A"}</P>
            )}
          </FormGroup>
          {/* discount_amt */}
          <FormGroup>
            <UL attrUL={{ className: "simple-list sub-total total" }}>
              <LI attrLI={{ className: "border-0 bg-transparent " }}>
                <b> Discounted Amount </b>
                {rowData.payment.some(
              (d) => d.discount_amt === null || d.discount_amt === undefined
            ) && permission?.create_access? (
                <span className="count">
                  &#x20B9;<b>{discountedAmount.toFixed(2)}</b>
                  <br />
                </span> ) : 
                 (
                    <span className="count">
                  &#x20B9;<b>{rowData.payment[0]?.discount_amt || "N/A"}</b>
                  <br />
                </span> 
                  )}
              </LI>
            </UL>
          </FormGroup>
          {permission?.edit_access &&<FormGroup switch>
        <Input
          type="switch"
          checked={edit}
          onClick={() => {
            setEdit(!edit)
          }}
        />
        <Label check>Edit Last Transaction Amount</Label>
      </FormGroup>}

      {edit &&  (
            <>
              <FormGroup className="mb-3">
                <Label for="amount">Last Transaction Amount</Label> <br />
                <h5>
                  {rowData.payment[0]["paid_amt"]
                    ? rowData.payment[0]["paid_amt"]
                    : "-"}
                </h5>
              </FormGroup>

              
            </>
          )}
             {((dueAmount !== 0) || edit) && permission?.create_access ? (
      <FormGroup className="mb-3">
        <Label for="amount">{"Amount to be paid"}</Label>
        <Controller
          name="amount"
          control={control}
          defaultValue=""
          rules={{
            validate: (value) => {
              const numericValue = parseFloat(value);
              return numericValue <= discountedAmount || "Amount must not exceed the discounted amount";
            },
          }}
          render={({ field }) => (
            <Input {...field} type="number" min="0" step="0.01" />
          )}
        />
        {errors.amount && (
          <span style={{ color: "#ff5370" }}>
            {errors.amount.message}
          </span>
        )}
      </FormGroup>
    ) : null}
          {/* {((dueAmount !== 0) || edit) && permission?.create_access ? <FormGroup className="mb-3">
            <Label for="amount">{"Amount to be paid"}</Label>
            <Controller
              name="amount"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <Input {...field} type="number" min="0" step="0.01" />
              )}
            />
            <span style={{ color: "#ff5370" }}>
              {errors.amount && "Please enter Amount"}
            </span>
          </FormGroup> : null} */}
          <div className="text-end">
          {((dueAmount !== 0) || edit) && permission?.create_access ?  
              <Button
                className="success m-2"
                type="submit"
                disabled={isSubmitting}
                color="success"
              >
                {isSubmitting ? "Submitting..." : "Pay Now"}
              </Button>
            : null}
            
              <Button
                className="success m-2"
                color="danger"
                onClick={handleBack}
              >
                {"Back"}
              </Button>
          
          </div>
        </Form>
      </Col>
    </Fragment>
  );
};

export default CheckoutTableData;
